import { swiperAssetsDefaultConfig } from 'src/app/swiper/swiper.module';
const ɵ0 = swiperAssetsDefaultConfig;
/** 素材detail頁面模組 */
export class DetailModule {
}
export { ɵ0 };
